import { useState } from "react"

import styled from 'styled-components'
import { IconButton } from "./IconButton"
import icon_collapse from '../../../../assets/images/icon-collapse.svg'
import icon_expand from '../../../../assets/images/icon-expand.svg'
import { BoxImage } from "./BoxImage"

export const Wrapper = styled.div<{
  cursor: string

}>`
  display: grid;
  grid-template-columns: 100px auto;
  grid-template-rows: 1fr auto;
  column-gap: 1rem;
  border-radius: var(--mid-border-radius);

  color: var(--black);
  background: var(--white);

  ${props => props.cursor ? 'cursor: ' + props.cursor + '; ' : ''}
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
  &:hover {
    text-decoration: none;
  }

  .expander-container {
    grid-column: 1 / 2; grid-row: 1 / 2;
    margin-left: 1rem;
    margin-top: 1rem;
    padding-bottom: 1rem;
  }
  .question-container {
    grid-column: 2 / 3; grid-row: 1 / 2;
    color: var(--black);
    margin-top: 1rem;
  }
  .answer-container {
    grid-column: 1 / 3; grid-row: 2 / 3;
    border-top: 1px solid #ccc;
    color: var(--black);
    padding-top: 1rem;
    padding-bottom: 1rem;

    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .answer-container p {
    font: 18px / 28px var(--body-font);
  }
`
interface ExpanderBarParams<T extends HTMLDivElement> extends React.HTMLProps<T> {
  heading: string
  
}


export const ExpanderBar = <T extends HTMLDivElement>(props: ExpanderBarParams<T>) => {

  const [isOpen, setIsOpen] = useState(false);

  
  // important! passing all props down to NavLink including my own ones like bgaColor is naughty in React's sight
  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  return (

    <Wrapper {...props} cursor='pointer'>
      <div className='expander-container' onClick={() => setIsOpen(!isOpen)}>
        <IconButton
          w='25px'
          h='25px'
          bWidth='0' bStyle='none'
          bgColor='transparent'
          bgaColor='transparent'
          p='2px'
          m='2px'
          icon={isOpen ? <BoxImage url={icon_collapse} w='50px' alt='open'/> : <BoxImage url={icon_expand} w='50px' alt='close'/>}
          
        />
      </div>
      <div className='question-container'><h3 style={{textTransform: 'none'}}>{props.heading}</h3></div>

      {isOpen && (
        <div className='answer-container' dangerouslySetInnerHTML={{ __html: `${props.content}` }}></div>
        
      )}

    
    </Wrapper>

  )
}